import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useUnifiedPerformance } from './useUnifiedPerformance';

/**
 * Wrapper pour useUnifiedPerformance qui utilise useLocation
 * À utiliser uniquement à l'intérieur du Router
 * Gère également le scroll-to-top automatique lors des changements de page
 */
export const useRouterPerformance = () => {
  const location = useLocation();
  
  // Scroll to top on every route change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  
  return useUnifiedPerformance(location.pathname);
};
